import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import GoodsJobInfo from 'view/goodsJobInfo';

const GoodsJobManagePage = () => {
	return (
		<PageTemplate>
			<GoodsJobInfo /> 
		</PageTemplate>
	);
};

export default GoodsJobManagePage;

 